export default __webpack_public_path__ + "static/s08-3129daa560ac7603ae34779ff2c49f40.png";